import { throttle } from 'lodash'

/**
 * Tab-and-scroll wiring for the stacked-section module editors.
 *
 * Every editor panel is one long scrolling column of `<div class="editor-section">`
 * blocks with a tab bar above it: scrolling moves the tab, clicking the tab
 * scrolls. The component supplies `tabs`; this supplies the rest.
 */
export default {
  data () {
    return {
      inputSectionTab: null,
    }
  },
  computed: {
    throttleScroll () {
      return throttle(this.onScroll, 100)
    },
  },
  mounted () {
    if (this.inputSectionTab === null && this.tabs.length) {
      this.inputSectionTab = this.tabs[0].id
    }
  },
  methods: {
    onScroll (event) {
      if (this._scrollingToSection) return
      const container = event.target
      const scrollTop = container.scrollTop
      const scrollingDown = scrollTop >= (this._lastScrollTop || 0)
      this._lastScrollTop = scrollTop
      const containerRect = container.getBoundingClientRect()
      const threshold = 10

      let activeSection = this.tabs[0]?.id
      for (const tab of this.tabs) {
        const el = container.querySelector(`#${tab.id}`)
        if (!el) continue
        if (el.getBoundingClientRect().top <= containerRect.top + threshold) {
          activeSection = tab.id
        }
      }

      // Only ever move the tab in the direction of travel, so a tall section
      // scrolling past does not flick the tab backwards.
      const currentIndex = this.tabs.findIndex(t => t.id === this.inputSectionTab)
      const newIndex = this.tabs.findIndex(t => t.id === activeSection)
      if (scrollingDown && newIndex >= currentIndex) {
        this.inputSectionTab = activeSection
      } else if (!scrollingDown && newIndex <= currentIndex) {
        this.inputSectionTab = activeSection
      }
    },
    scrollToSection (sectionId) {
      this._scrollingToSection = true
      this.inputSectionTab = sectionId
      const container = this.$el.querySelector('.editor')
      const el = container && container.querySelector(`#${sectionId}`)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', })
      }
      clearTimeout(this._scrollTimer)
      this._scrollTimer = setTimeout(() => { this._scrollingToSection = false }, 400)
    },
  },
}
